import { useState, useEffect, useCallback } from 'react';

export function useTypewriter(phrases, {
  typeSpeed = 80,
  deleteSpeed = 40,
  pauseDelay = 2000,
} = {}) {
  const [text, setText] = useState('');
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  const tick = useCallback(() => {
    const currentPhrase = phrases[phraseIndex];

    if (!isDeleting) {
      setText(currentPhrase.substring(0, text.length + 1));

      if (text.length + 1 === currentPhrase.length) {
        setTimeout(() => setIsDeleting(true), pauseDelay);
        return;
      }
    } else {
      setText(currentPhrase.substring(0, text.length - 1));

      if (text.length - 1 === 0) {
        setIsDeleting(false);
        setPhraseIndex((prev) => (prev + 1) % phrases.length);
        return;
      }
    }
  }, [text, phraseIndex, isDeleting, phrases, pauseDelay]);

  useEffect(() => {
    const speed = isDeleting ? deleteSpeed : typeSpeed;
    const timer = setTimeout(tick, speed);
    return () => clearTimeout(timer);
  }, [tick, isDeleting, typeSpeed, deleteSpeed]);

  return text;
}
